<template>
  <div
    :class="[
      cell.isAnswer ? 'column' : 'containerAnswer',
      isInFirstRow && 'isInFirstRow',
      'p-0',
    ]"
    :data-positiony="cell.positiony"
    :data-positionx="cell.positionx"
  >
    <div
      v-if="cell.isAnswer"
      class="d-flex flex-column p-0 w-100 h-100"
      @dblclick="onDoubleClick(cell)"
    >
      <div class="symbol" :style="'font-family:' + font" v-if="!locked && font">
        {{ cell.text }}
      </div>
      <input
        autocomplete="off"
        type="text"
        :maxlength="1"
        ref="input"
        :class="['cell-input no-print bg-white', { backgroundLocked: locked }]"
        v-model="cell.text"
        @keyup="changeLetter(cell)"
        @mouseover="focusInput"
        @mouseout="blurInput"
      />
      <div
        :class="[
          'w-100 h-100 text-center bg-white printElement',
          { backgroundLocked: locked },
        ]"
      >
        <p>{{ cell.text }}</p>
      </div>
    </div>
    <div
      v-else
      :class="[
        'd-flex align-items-center w-100',
        isInFirstRow && 'isInFirstRow',
      ]"
    >
      <d-button
        class="btn btn-outline-dark mr-2 p-2 custom_button no-print"
        data-toggle="tooltip"
        :title="$t('cryptogramGenerator.cell.fillWord')"
        @click="getWordByTerm(cell.positionx)"
      >
        <i class="material-icons">refresh</i>
      </d-button>
      <d-button
        class="btn btn-outline-dark mr-2 p-2 custom_button no-print"
        data-toggle="tooltip"
        :title="$t('cryptogramGenerator.cell.clearLine')"
        @click="clearLine(cell.positionx)"
      >
        <i class="material-icons">delete</i>
      </d-button>
      <div class="h-100 d-flex flex-grow-1">
        <questions
          ref="searchQuestion"
          :items="words"
          :line="cell.positionx.toString()"
          :cell="cell"
          @update-question="updateQuestion"
          item-show="question"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Questions from './Questions.vue';

export default {
  name: 'cryptogram-cell',
  props: {
    cell: {
      type: Object,
      require: true,
    },
    clearLine: {
      type: Function,
    },
    getWordLine: {
      type: Function,
    },
    getWordByTerm: {
      type: Function,
    },
    font: {
      type: String,
      require: true,
    },
  },
  components: {
    Questions,
  },
  computed: {
    isInFirstRow() {
      return this.cell.positionx === '0';
    },
    locked() {
      return this.cell.settings.locked;
    },
  },
  data() {
    return {
      words: [],
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    changeLetter(cell) {
      cell.text = cell.text ? cell.text.toUpperCase() : '';
      this.$emit('on-input');
    },
    onDoubleClick(cell) {
      if (cell.text === null) cell.text = '';

      if (cell.isAnswer) {
        const newStatus = !cell.settings.locked;
        cell.settings.locked = newStatus;
        this.$emit('bg-color-change', newStatus);
      }
    },
    focusInput() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    blurInput() {
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    setQuestion(question) {
      if (this.$refs.searchQuestion && question) {
        this.$refs.searchQuestion.$refs[`input-${this.cell.positionx}`].value =
          question;
      }
    },
    updateQuestion(question) {
      this.cell.text = question.question;
      this.cell.question_id = question.id;
      this.cell.answer_id = question.answer_id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
@import '~_scss/cryptogram';
p {
  margin: 0;
  font-weight: bold;
  font-size: 24px;
}
.cell-input {
  border: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}

.cell-input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.containerAnswer {
  display: flex;
}

.symbol {
  width: 100%;
  height: 35%;
  text-align: center;
  font-size: 18px;
  line-height: 16px;
  margin-top: 8px;
  color: #444;
}

.printElement {
  display: none;
}

.backgroundLocked {
  background-color: $gray !important;
}
</style>
